import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const IlanGoruntulenmeLog = () => {
  document.title = "İlan Görüntüleme Logları | HarmanaGEL";

  const [loglar, setLoglar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLoglar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      // ILAN_GORUNTULENME_LOG'da sadece ILANLAR navigation var, KULLANICILAR ile EF mapping yok.
      // Kullanıcı bilgisini ayrı lookup ile çekip listeye eşliyoruz.
      const response = await fetch(
        `${BASE_URL}/ILAN_GORUNTULENME_LOG?$top=500&$orderby=GORUNTULENME_TARIHI desc&$expand=ILANLAR($select=AD)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      const list = (result && result.value) || [];

      const userIds = Array.from(new Set(list.map(l => l.KULLANICI_ID).filter(Boolean)));
      let userMap = {};
      if (userIds.length > 0) {
        const filterStr = userIds.map(id => `ID eq ${id}`).join(' or ');
        const uRes = await fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD&$filter=${filterStr}`, { headers: getAuthHeaders() });
        const uJson = await uRes.json();
        (uJson?.value || []).forEach(u => { userMap[u.ID] = u; });
      }
      const enriched = list.map(l => ({
        ...l,
        USER: l.KULLANICI_ID ? userMap[l.KULLANICI_ID] || null : null,
      }));
      setLoglar(enriched);
    } catch (err) {
      setError("Loglar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLoglar();
  }, []);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "İlan",
      accessorKey: "ILANLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const i = cell.getValue();
        return i ? <span className="fw-medium">{i.AD}</span> : <span className="text-muted">İlan #{cell.row.original.ILAN_ID}</span>;
      },
    },
    {
      header: "Kullanıcı",
      accessorKey: "USER",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? <span className="fw-medium">{u.AD_SOYAD}</span> : <span className="text-muted">Misafir / #{cell.row.original.KULLANICI_ID || "-"}</span>;
      },
    },
    {
      header: "IP Adresi",
      accessorKey: "IP_ADRESI",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span className="font-monospace small">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Görüntülenme Tarihi",
      accessorKey: "GORUNTULENME_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="İlan Görüntüleme Logları" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">İlan Görüntüleme Geçmişi</h4>
                    <Button color="primary" size="sm" onClick={fetchLoglar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={loglar}
                      isGlobalFilter={true}
                      SearchPlaceholder="İlan ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IlanGoruntulenmeLog;
